<template>
  <el-container class="home-container">
    <el-header>
      <div class="left">
        <!-- <div
          :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
          id="toggle-btn"
          @click="toggleCollapse"
        ></div> -->
        <img :src="formSite.imageUrl" alt="" class="logoimg" />
        <span>{{ formSite.SystemName }}</span>
      </div>
      <div class="right"></div>
      <el-dropdown>
        <span class="el-dropdown-link">
          <span class="user_role_text"
            >用户角色：{{
              userinfo.LoginType === '1' ? '管理员' : '评审老师'
            }}</span
          >
          <span class="el-icon-s-custom"></span>
          {{ userinfo.JudgesName
          }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="showPwdDialogVisible"
            >修改密码</el-dropdown-item
          >
          <el-dropdown-item @click.native="logout">退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-header>
    <el-container>
      <el-aside :width="isCollapse ? '64px' : '200px'">
        <!-- 菜单 -->
        <el-menu
          background-color="#fff"
          text-color="#333"
          active-text-color=""
          :unique-opened="true"
          :collapse="isCollapse"
          :collapse-transition="false"
          :router="true"
          :default-active="defaultActive"
        >
          <div v-for="item in menulist" :key="item.path">
            <!-- 无子菜单 -->
            <template v-if="item.children && item.children.length === 0">
              <el-menu-item :index="item.path">
                <i :class="iconobj[item.id]"></i>
                <span slot="title">{{ item.authName }}</span>
              </el-menu-item>
            </template>
            <!-- 有子菜单 -->
            <el-submenu v-else :index="item.path">
              <template slot="title">
                <i :class="iconobj[item.id]"></i>
                <span slot="title">{{ item.authName }}</span>
              </template>
              <!-- 二级菜单 -->
              <template v-for="subitem in item.children">
                <sidebar-item
                  v-if="subitem.children && subitem.children.length > 0"
                  :key="subitem.path"
                />
                <el-menu-item
                  v-else
                  :key="subitem.path"
                  :item="subitem"
                  :index="subitem.path"
                >
                  <i class="el-icon-menu"></i>
                  <span slot="title">{{ subitem.authName }}</span>
                </el-menu-item>
              </template>
            </el-submenu>
          </div>
        </el-menu>
        <!-- 菜单 -->
      </el-aside>
      <el-main>
        <!-- 路由占位符 -->
        <router-view></router-view>
      </el-main>

      <!-- 修改密码 -->
      <el-dialog title="密码修改" :visible.sync="pwdDialogVisible" width="30%">
        <el-form
          :model="pwdForm"
          :rules="pwdFormRules"
          ref="pwdFormRef"
          label-width="130px"
          @close="pwdDialogClosed"
        >
          <el-form-item label="原密码" prop="OldJudgesPwd">
            <el-input v-model="pwdForm.OldJudgesPwd"></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="JudgesPwd">
            <el-input v-model="pwdForm.JudgesPwd"></el-input>
          </el-form-item>
          <el-form-item label="确认新密码" prop="JudgesPwdConfirm">
            <el-input v-model="pwdForm.JudgesPwdConfirm"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="pwdDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="changePwd()">确 定</el-button>
        </span>
      </el-dialog>
    </el-container>
  </el-container>
</template>

<script>
import bus from '../../bus'
export default {
  data() {
    var validateNewPwd = (rule, value, cb) => {
      if (value !== this.pwdForm.JudgesPwd) {
        cb(new Error('两次输入密码不一致'))
      } else {
        cb()
      }
    }
    return {
      menulist: [],
      adminmenulist: [
        {
          id: 101,
          authName: '赛项管理',
          path: 'eventManagement',
          children: [
            {
              id: 201,
              authName: '创建赛事',
              path: 'createEvent',
              children: []
            },
            {
              id: 202,
              authName: '设置赛道',
              path: 'setTrack',
              children: []
            }
          ]
        },
        {
          id: 102,
          authName: '赛项评审管理',
          path: 'eventReviewManagement',
          children: [
            {
              id: 203,
              authName: '设置评审标准',
              path: 'standard',
              children: []
            },
            {
              id: 204,
              authName: '设置评委小组',
              path: 'judges',
              children: []
            },
            {
              id: 205,
              authName: '赛事评委库',
              path: 'judgelib',
              children: []
            }
          ]
        },
        {
          id: 103,
          authName: '作品管理',
          path: 'project',
          children: [
            {
              id: 206,
              authName: '作品查看',
              path: 'view',
              children: []
            },
            {
              id: 207,
              authName: '作品评审分配',
              path: 'grouping',
              children: []
            }
          ]
        },
        {
          id: 104,
          authName: '赛事视频管理',
          path: 'video',
          children: [
            {
              id: 208,
              authName: '设置培训视频',
              path: 'training',
              children: []
            }
          ]
        },
        {
          id: 105,
          authName: '会员管理',
          path: 'users',
          children: []
        },
        {
          id: 108,
          authName: '学校管理',
          path: 'school',
          children: []
        },
        {
          id: 106,
          authName: '信息查询',
          path: 'info',
          children: [
            // {
            //   id: 209,
            //   authName: '查看项目',
            //   path: 'viewProject',
            //   children: []
            // },
            {
              id: 210,
              authName: '评审进度',
              path: 'progresss',
              children: []
            },
            // {
            //   id: 211,
            //   authName: '项目得分',
            //   path: 'score',
            //   children: []
            // },
            {
              id: 212,
              authName: '作品排名',
              path: 'ranking',
              children: []
            }
          ]
        },
        {
          id: 107,
          authName: '内容管理',
          path: 'content',
          children: [
            {
              id: 213,
              authName: '文章管理',
              path: 'article',
              children: []
            },
            {
              id: 214,
              authName: '赛事图片',
              path: 'matchimglist',
              children: []
            }
          ]
        },
        {
          id: 1081,
          authName: '推荐数设置',
          path: 'recommendset',
          children: []
        },
        {
          id: 109,
          authName: '基本设置',
          path: 'set',
          children: [
            {
              id: 215,
              authName: '会员内容设置',
              path: 'reviewsettings',
              children: []
            },
            {
              id: 216,
              authName: '站点设置',
              path: 'website',
              children: []
            },
            {
              id: 217,
              authName: '参数设置',
              path: 'param',
              children: []
            },
            {
              id: 218,
              authName: '注册登录设置',
              path: 'regset',
              children: []
            }
          ]
        }
      ],
      reviewmenulist: [
        {
          id: 110,
          authName: '首页',
          path: 'reviewwelcome',
          children: []
        },
        {
          id: 112,
          authName: '作品评审',
          path: 'workreview',
          children: []
        }
      ],
      iconobj: {
        101: 'el-icon-s-flag',
        102: 'el-icon-s-comment',
        103: 'el-icon-s-marketing',
        104: 'el-icon-video-camera-solid',
        105: 'el-icon-user-solid',
        106: 'el-icon-s-help',
        107: 'el-icon-s-order',
        108: 'el-icon-s-shop',
        1081: 'el-icon-s-tools',
        109: 'el-icon-s-tools'
      },
      isCollapse: false,
      defaultActive: '1',
      // 密码弹框显示状态
      pwdDialogVisible: false,
      pwdForm: {
        OldJudgesPwd: '',
        JudgesPwd: '',
        JudgesPwdConfirm: '',
        LoginID: ''
      },
      pwdFormRules: {
        OldJudgesPwd: [
          {
            required: true,
            trigger: 'blur',
            message: '请输入原始密码'
          }
        ],
        JudgesPwd: [
          {
            required: true,
            trigger: 'blur',
            message: '请输入新密码'
          }
        ],
        JudgesPwdConfirm: [
          {
            required: true,
            trigger: 'blur',
            message: '请再次输入新密码'
          },
          {
            validator: validateNewPwd,
            trigger: 'blur',
            required: true
          }
        ]
      },
      // 用户角色名称
      userinfo: {
        // 用户名
        LoginID: '',
        // 角色id
        LoginType: '',
        JudgesName: ''
      },
      // logo信息
      formSite: {
        imageUrl: '',
        SystemName: ''
      }
    }
  },
  created() {
    // 打开页面就获取菜单
    // this.getMenuList()
    // console.log(this.$route.path)
    this.getUserInfo()
    // 默认加载logo
    this.getLogoInfo()
  },
  methods: {
    logout() {
      window.localStorage.clear()
      this.$router.push('/login')
    },
    getUserInfo() {
      this.userinfo.LoginID = window.localStorage.getItem('LoginID')
      this.userinfo.JudgesName = window.localStorage.getItem('JudgesName')
      this.userinfo.LoginType = window.localStorage.getItem('LoginType')
      if (this.userinfo.LoginType === '1') {
        this.menulist = this.adminmenulist
      } else {
        this.menulist = this.reviewmenulist
      }
    },
    // 回填logo和系统名称
    async getLogoInfo() {
      const { data: res } = await this.$http.get(
        '/api/SiteSettings/GetSiteSettings'
      )
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.formSite = {
        imageUrl: process.env.VUE_APP_BASE_URL + res.Data.FileName,
        SystemName: res.Data.SystemName
      }
    },
    // 获取所有菜单
    // async getMenuList() {
    //   const { data: res } = await this.$http.get('/api/menus')
    //   // 判断数据如果没有获取成功就提示失败信息
    //   if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
    //   this.menulist = res.data
    //   // console.log(res)
    // },
    toggleCollapse() {
      this.isCollapse = !this.isCollapse
    },
    // 重置表单验证
    pwdDialogClosed() {
      this.$refs.pwdFormRef.resetFields()
    },
    showPwdDialogVisible() {
      this.pwdDialogVisible = true
    },
    // 修改密码
    changePwd() {
      this.$refs.pwdFormRef.validate(async (valid) => {
        if (!valid) return
        var loginid = window.localStorage.getItem('LoginID')
        this.pwdForm.LoginID = loginid
        const { data: res } = await this.$http.post(
          '/api/Judges/EditJudgesPwd',
          this.pwdForm
        )
        if (res.StatusCode !== 1) return this.$message.error(res.Msg)
        this.pwdDialogVisible = false
        this.$message.success('修改成功，即将退出，请从新登录')
        // 修改成功后，3S后退出
        const _this = this
        setTimeout(() => {
          _this.logout()
        }, 3000)
      })
    }
  },
  mounted() {
    // 接收WebSite.vue页面发送的数据
    bus.$on('uplogosrc', (data) => {
      this.formSite = data
    })
  }
}
</script>
<style lang="less" scoped>
.home-container {
  height: 100%;
}
.el-header {
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 0 6px #ddd;
  margin-bottom: 10px;
  .left {
    height: 100%;
    display: flex;
    align-items: center;
    font-size: 18px;
    img {
      height: 30px;
      margin-right: 10px;
    }
    span {
      margin: 0;
    }
    #toggle-btn {
      font-size: 30px;
      margin-left: 10px;
      margin-right: 10px;
    }
  }
}
.el-aside {
  box-shadow: 0 0 6px #ddd;
}
.user_role_text {
  margin-right: 20px;
  color: #999;
}
</style>
